// DS: UI01
/** A styled radio button control for forms */
import React from 'react';
import classnames from 'classnames';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import noop from '../utils/noop';
import s from './RadioButton.scss';
var RadioButton = function (_a) {
    var name = _a.name, _b = _a.onChange, onChange = _b === void 0 ? noop : _b, value = _a.value, className = _a.className, checked = _a.checked, children = _a.children, ariaDescribedBy = _a["aria-describedby"], _c = _a.disabled, disabled = _c === void 0 ? false : _c, biData = _a.biData;
    return (React.createElement("label", { className: classnames(s['option'], className) },
        React.createElement(BiInput, { type: "radio", name: name, value: value, onChange: onChange, checked: checked, "aria-describedby": ariaDescribedBy, biData: biData, disabled: disabled }),
        children));
};
RadioButton.displayName = 'RadioButton';
export default RadioButton;
//# sourceMappingURL=RadioButton.js.map